interface ActionTypes {
  FETCH_USER_ORGANISATION_START: string;
  FETCH_USER_ORGANISATION_SUCCESS: string;
  FETCH_USER_ORGANISATION_FAILURE: string;
}

export const OrganisationActionTypes: ActionTypes = {
  FETCH_USER_ORGANISATION_START: '@@FETCH_USER_ORGANISATION_START',
  FETCH_USER_ORGANISATION_SUCCESS: '@@FETCH_USER_ORGANISATION_SUCCESS',
  FETCH_USER_ORGANISATION_FAILURE: '@@FETCH_USER_ORGANISATION_FAILURE'
};

export interface OrganisationState {
  currentUserOrganisation?: any;
  isGettingUserOrganisation?: boolean;
}
